const initialStore = {
    // ui related
    isAsyncRequest: 0, // number
    isError404: false,
    isRedirectedOnceNoCompany: false,
    isInitialAuthLoading: true,
    // user
    userData: {},
    token: '',
    companies: [],
    chosenCompanyId: 0,
    users: [],
    // bando form
    formInitialData: {},
    documentCategories: [],
    // form builder
    formId: 0,
    formLabel: '',
    formElements: [],
    elementItems: [],
    activeElement: '',
    selectedElement: '',
    draggingElementId: 0,
    bandoCriteria: [],
    chosenFieldSettings: [],
    // flow
    flowData: [],
    flowForms: [],
    flowEdges: []
}

export default initialStore;